import { useEffect, useState } from 'react';
import { pathsAPI } from '../api/pathsAPI';

// { capability_key: display_name } from GET /api/paths/capabilities, fetched
// once per page load and shared by every row that names an app ("Open TMUA
// Practice"). Plan items carry only capability_key, and a raw key must never
// reach the page. Until the catalogue arrives, or if it fails, the map is
// empty and buttons read "Open the app". A failed fetch is retried by the
// next component that mounts.

let cached = null;
let inFlight = null;

function load() {
  if (cached) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = pathsAPI.getCapabilities()
      .then((list) => {
        cached = Object.fromEntries(
          (Array.isArray(list) ? list : [])
            .filter((c) => c && typeof c.capability_key === 'string' && typeof c.display_name === 'string')
            .map((c) => [c.capability_key, c.display_name]),
        );
        return cached;
      })
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}

export default function useCapabilityNames() {
  const [names, setNames] = useState(() => cached || {});

  useEffect(() => {
    if (cached) return undefined;
    let cancelled = false;
    load()
      .then((loaded) => { if (!cancelled) setNames(loaded); })
      .catch(() => { /* names stay empty; buttons read "Open the app" */ });
    return () => { cancelled = true; };
  }, []);

  return names;
}

// Tests only: forget the cached catalogue between cases.
export function resetCapabilityNamesCache() {
  cached = null;
  inFlight = null;
}
